<template>
    <div style="position:fixed; top: 40px; right: 220px;">
        <v-menu v-model="onShow"
                :nudge-width="200"
                :nudge-rigth="10"
                offset-y
                attach
                dark>


            <v-card>
                <v-card-text v-if="loggedIn">
                    <v-list>
                        <v-list-tile>

                            <v-list-tile-content>
                                <v-list-tile-title>{{name}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{username}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>

                    <v-divider></v-divider>
                </v-card-text>

                <v-card-actions>
                    <v-flex xs12 class="text-xs-left">
                        <v-btn id="current_user_info_navigate_to_user_preferences_button" class="text-none" small flat
                               to="/userpreferences" v-if="loggedIn">
                            <v-icon small left>fas fa-cog</v-icon>
                            <span>User preferences</span>
                        </v-btn>
                    </v-flex>
                </v-card-actions>

                <v-card-actions>
                    <v-flex xs12 class="text-xs-left">
                        <v-btn id="current_user_info_logout_button" small flat to="/logout" v-if="loggedIn">
                            <v-icon small left>fas fa-sign-out-alt</v-icon>
                            <span>Logout</span>
                        </v-btn>
                        <v-btn id="current_user_info_login_button" small flat to="/login" v-else>
                            <v-icon small left>fas fa-sign-in-alt</v-icon>
                            <span>Login</span>
                        </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>

<script>


    export default {
        name: "CurrentUserInfo",


        props: {
            value: Boolean,
            loggedIn: Boolean,
            name: String,
            username: String
        },
        computed: {
            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        data: () => ({
            showCurrentUser: false
        })
    }
</script>
<style>
    .menu {
        background-color: rgb(70, 70, 75);
        color: rgb(70, 70, 75);
    }
</style>


// WEBPACK FOOTER //
// src/components/common/users/modals/CurrentUserInfo.vue